/** @format */

import React, { Component } from 'react';
import { Modal, Header, Icon, Form } from 'semantic-ui-react';
import isRestrictedUser from '../../../helpers/isRestrictedUser';
import { observer, inject } from 'mobx-react';

@inject('UserStore')
@observer
class LocationModal extends Component {
  state = {
    open: true,
    options: [
      { text: 'Cagliari', value: 'Cagliari' },
      { text: 'Iglesias', value: 'Iglesias' },
      { text: 'Autodemolizione', value: 'Autodemolizione' },
    ],
    location: undefined,
  };

  getAvailableOptions = () => {
    const { UserStore } = this.props;
    const email = UserStore.user ? UserStore.user.email : null;
    if (isRestrictedUser(email)) {
      return [{ text: 'Autodemolizione', value: 'Autodemolizione' }];
    }
    return this.state.options;
  };

  setLocation = selection => {
    const { UserStore } = this.props;
    let location = selection.value;
    this.setState({ open: false }, () => {
      UserStore.setLocation(location);
    });
  };

  render() {
    return (
      <Modal open={this.state.open}>
        <Header className="modal-header" as="h3">
          <small>
            <Icon name="pin" />
          </small>
          Seleziona Sede di lavoro
        </Header>
        <div className="header-spacer"></div>
        <Modal.Content>
          <Form onSubmit={() => this.setWorkLocation()}>
            <Form.Group widths="equal">
              <Form.Select
                placeholder="Seleziona location"
                onChange={(e, selection) => this.setLocation(selection)}
                label="Sede di lavoro"
                fluid
                value={this.state.location}
                options={this.getAvailableOptions()}
              />
            </Form.Group>
          </Form>
        </Modal.Content>
      </Modal>
    );
  }
}

export default LocationModal;
